import { CarWindshieldOutlineIcon } from './CarWindshieldOutlineIcon';

/**
 * author: Michael Richins
 * id 55F7CDA2-F41C-42C4-8154-1F8B1C603F25
 * name car-windshield-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-windshield-outline.svg
 * tags
 * - Automotive 
 */
export const CarFrontGlassOutlineIcon = CarWindshieldOutlineIcon;
export default CarFrontGlassOutlineIcon